import { __read } from 'tslib';
import React__default, { useMemo, useState, useEffect } from 'react';
import classNames from 'classnames';
import { CloseStroke } from '../../assets/icons/CloseStroke.esm.js';
import { useTextCopy } from '@invitae/cms-blocks';
import { NvFinePrint, NvSelect, NvButton } from '@invitae/ids-react';
import { useBrowserActions, useCountryLocationPrefix, useLocationLiteCookie, CountryOptions, LOCATION_LITE_COOKIE_DATA_VERSION } from '@invitae/nucleobase-engine-contentful';
import styles from './CountrySwitcher.module.esm.js';

var SESSION_STORAGE_LABEL = 'countrySwitcherBanner';
var CountrySwitcherValue;
(function (CountrySwitcherValue) {
    CountrySwitcherValue["CLOSE"] = "close";
    CountrySwitcherValue["CONTINUE"] = "continue";
})(CountrySwitcherValue || (CountrySwitcherValue = {}));
var CountrySwitcher = function (_a) {
    var _b;
    var show = _a.show;
    var browserActions = useBrowserActions();
    var _c = useCountryLocationPrefix(), getCountryCodeFromPath = _c.getCountryCodeFromPath, changeUrlPrefix = _c.changeUrlPrefix;
    var _d = __read(useLocationLiteCookie(), 2), cookieCountry = _d[0], setCookieCountry = _d[1];
    var defaultValue = useMemo(function () { return CountryOptions.find(function (country) { return country.value === (cookieCountry === null || cookieCountry === void 0 ? void 0 : cookieCountry.countryCode); }); }, [cookieCountry === null || cookieCountry === void 0 ? void 0 : cookieCountry.countryCode]);
    var getText = useTextCopy().getText;
    var _e = __read(useState(defaultValue), 2), localCountry = _e[0], setLocalCountry = _e[1];
    var _f = __read(useState(!!show), 2), showBanner = _f[0], setShowBanner = _f[1];
    var isWindowDefined = typeof window !== 'undefined';
    var isStorageDefined = typeof sessionStorage !== 'undefined';
    var isCountrySwitcherNotClosed = isStorageDefined && sessionStorage.getItem(SESSION_STORAGE_LABEL) !== CountrySwitcherValue.CLOSE;
    /**
     * Verify if we need to show banner or not
     * it needs to be inside useEffect cause we depends to sessionStorage be defined
     */
    useEffect(function () {
        setShowBanner(isCountrySwitcherNotClosed);
        if (isCountrySwitcherNotClosed) {
            setLocalCountry(defaultValue);
        }
    }, [isCountrySwitcherNotClosed, defaultValue]);
    var closeBanner = function (value) {
        sessionStorage.setItem(SESSION_STORAGE_LABEL, CountrySwitcherValue[value]);
        setShowBanner(false);
    };
    var onClick = function () {
        var _a;
        if (!(localCountry === null || localCountry === void 0 ? void 0 : localCountry.value))
            return;
        var countryCode = localCountry.value;
        setCookieCountry({ countryCode: countryCode, setBy: 'fallback' });
        var countryPath = getCountryCodeFromPath((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname);
        /**
         * just reloads the page if is diff than the current URL country code
         */
        if (countryCode.toLowerCase() !== countryPath) {
            var url = changeUrlPrefix(browserActions.getPath(), countryCode);
            browserActions.replace(url);
        }
        closeBanner('CONTINUE');
    };
    /**
     * As this component depends on the URL, should just be rendered when window is defined
     */
    if (!isWindowDefined)
        return null;
    var countryPath = getCountryCodeFromPath(browserActions.getPath());
    /**
     * if there is no cookie should return not render
     */
    if (!(cookieCountry === null || cookieCountry === void 0 ? void 0 : cookieCountry.countryCode))
        return null;
    /**
     * The component will only be rendered when showBanner is true or when the cookie country is different from the URL country
     */
    if (((_b = cookieCountry === null || cookieCountry === void 0 ? void 0 : cookieCountry.countryCode) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === countryPath ||
        (cookieCountry === null || cookieCountry === void 0 ? void 0 : cookieCountry.version) < LOCATION_LITE_COOKIE_DATA_VERSION ||
        !showBanner)
        return null;
    /**
     * Scroll to top to show banner
     */
    window.scrollTo({
        behavior: 'smooth',
        top: 0,
    });
    return (React__default.createElement("aside", { className: styles.wrapper },
        React__default.createElement("div", { className: classNames('nv-container', styles.content) },
            React__default.createElement("div", { className: styles.textWrapper },
                React__default.createElement(NvFinePrint, { className: styles.text }, getText('countrySwitcherText'))),
            React__default.createElement("div", { className: styles.switchCountry },
                React__default.createElement(NvSelect, { classes: { root: styles.selectComponent }, hideLabel: true, label: "Country", name: "countryCode", onChange: function (value) { return setLocalCountry(value); }, options: CountryOptions, value: localCountry }),
                React__default.createElement(NvButton, { onClick: onClick }, "Continue"),
                React__default.createElement(NvButton, { className: styles.closePanel, onClick: function () { return closeBanner('CLOSE'); }, size: "small", variant: "plain" },
                    React__default.createElement(CloseStroke, null))))));
};

export { CountrySwitcher, CountrySwitcherValue, SESSION_STORAGE_LABEL };
//# sourceMappingURL=CountrySwitcher.esm.js.map
